<template>
  <div id="membersRecordDialog">
    <el-dialog
      title=""
      custom-class='innerPageDialog'
      @close="OnClose"
      top="0"
      :modal='false'
      width="100%"
      :visible.sync="visible"
    >
      <div class="opreationBox opreationOtherName">
        <el-form
          :inline="true"
          :model="formInline"
          class="demo-form-inline"
          label-width="100px"
        >
          <el-form-item label="用户名：">
            <span>{{desObj.name}}</span>
          </el-form-item>
          <el-form-item
            label="完成状态"
            label-width="100px"
          >
            <el-select
              v-model="formInline.FinishState"
              placeholder="请选择完成状态"
              @change="handleCurrentChange(1)"
            >
              <el-option
                v-for="item in FinishStateList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label=""
            label-width="0"
          >
            <el-button
              @click="OnClose"
              type="primary"
            >关闭详情</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="tableBox">
        <el-table
          v-loading="loading"
          :height="tableH"
          :data="recordList"
          border
          style="width: 100%"
        >
          <el-table-column
            header-align="center"
            prop="qusetionnaireTitle"
            label="问卷名称 "
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="完成状态"
          >
            <template slot-scope="scope">
              <template v-for="(item,index) in FinishStateList">
                <span
                  :key="index"
                  :style="{color:item.color}"
                  v-if="item.value==scope.row.finishState"
                >{{ item.label}}</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="receivePrice"
            label="理论报酬 "
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="actualPrice"
            label="实际报酬 "
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shareUserName"
            label="分享人 "
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="创建时间"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.createTime?scope.row.createTime.slice(0,10):''}}</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="完成时间"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.finishTime?scope.row.finishTime.slice(0,10):''}}</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="是否已提现"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.hasRecieve?'已提现':'未提现'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="提现时间"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.recieveTime?scope.row.recieveTime.slice(0,10):''}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pageBox">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageObj.PageIndex"
          :page-sizes="[2, 4, 10, 20, 50, 100]"
          :page-size="pageObj.PageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageObj.total"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getRecords } from 'api/request'
import { SetTableH } from '../../../utils/utils'
export default {
  props: {
    showDes: {
      type: Boolean,
      default: function() {
        return false
      }
    },
    desObj: {
      type: Object,
      default: function() {
        return null
      }
    }
  },
  data() {
    return {
      loading: true,
      visible: this.showDes,
      tableH: '250',
      dataObj: null,
      formInline: {
        FinishState: -1
      },
      pageObj: {
        total: 0,
        PageIndex: 1,
        PageSize: 10
      },
      FinishStateList: [
        {
          value: -1,
          label: '全部',
          color: ''
        },
        {
          value: 0,
          label: '未完成',
          color: ''
        },
        {
          value: 1,
          label: '被甄别',
          color: ''
        },
        {
          value: 2,
          label: '完成',
          color: ''
        },
        {
          value: 3,
          label: '完成但名额超出',
          color: ''
        }
      ],
      recordList: []
    }
  },
  watch: {
    showDes: {
      immediate: true,
      handler(showDes) {
        this.visible = this.showDes
      }
    }
  },
  components: {},
  methods: {
    handleSizeChange(val) {
      this.pageObj.PageSize = val
      this.getRecordDes()
    },
    handleCurrentChange(val) {
      this.pageObj.PageIndex = val
      this.getRecordDes()
    },
    async getRecordDes() {
      let params = {
        id: this.desObj.id,
        searchParams: {
          PageIndex: this.pageObj.PageIndex,
          PageSize: this.pageObj.PageSize,
          FinishState: this.formInline.FinishState
        }
      }
      this.loading = true
      let data = await getRecords(params)
      if (data) {
        this.recordList = data.rows
        this.pageObj.total = data.total
        this.loading = false
      }
    },
    OnClose() {
      this.$emit('update:showDes', false)
    }
  },
  mounted() {
    SetTableH(this, '.opreationOtherName')
  },
  created() {
    this.getRecordDes()
  }
}
</script>
<style lang='scss'>
#membersRecordDialog {
  height: 100%;
  width: 100%;
  .formBox {
    width: 200px;
  }
  .pageBox {
    margin-top: 20px;
    text-align: right;
  }
  .el-dialog__wrapper {
    position: fixed;
    top: 60px;
    right: 0;
    bottom: 0;
    left: 210px;
    overflow: auto;
    margin: 0;
    z-index: 99 !important;
    .innerPageDialog {
      margin: 0;
      height: 100%;
      .el-dialog__header {
        display: none;
      }
      .el-dialog__body {
        padding: 20px;
        height: 100%;
        box-sizing: border-box;
      }
    }
  }
}
</style>
